import React from "react";
import { Modal } from "semantic-ui-react";
import "./CustomModal.css"; // Custom CSS file for modal styling

const DublicateConfirmation = ({ open, onClose, onConfirm, message = "Are you sure?" }) => {
  return (
    <Modal open={open} onClose={onClose} size="small" className="custom-modal">
      <Modal.Content>
        <button
          type="button"
          className="close linear-gradient"
          onClick={onClose}
          aria-label="Close"
        >
          X
        </button>
        <div className="modal-header">
          <h5 className="modal-title">Confirm your action</h5>
        </div>
        <p className="custom-modal-content">{message}</p>
      </Modal.Content>
      <div className="modal-footer">
        <button
          type="button"
          className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
          onClick={onClose}
        >
          <span>No</span>
        </button>
        <button
          type="button"
          onClick={onConfirm}
          className="btn linear-gradient yr-submitbtn btn-sm"
        >
          Yes
        </button>
      </div>
    </Modal>
  );
};

export default DublicateConfirmation;
